'use strict';

import { upperCaseFirst } from '@utils/TextUtil';

export const PROVIDERS = {
    FITBIT: 'fitbit',
    GOOGLE_HEALTH: 'google_health',
};

export const PROVIDER_LABELS = {
    fitbit: 'Fitbit',
    google_health: 'Google Health',
};

export const formatProviderName = (provider) =>
    PROVIDER_LABELS[provider] || upperCaseFirst(provider);
